import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { API_URL } from '../config';
import { noAutofill } from '../noAutofill';

interface LoginProps {
  onLogin: () => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      const response = await fetch(`${API_URL}/api/credentials`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ superpossible_key: password }),
      });

      const data = await response.json();

      if (data && data.success === true) {
        localStorage.setItem('superpossible_key', password);
        onLogin();
      } else {
        setError('That key was not recognised. Check it and try again.');
      }
    } catch (err) {
      console.error('Error validating superpossible key:', err);
      setError('We could not reach the server. Try again in a moment.');
    }

    setIsLoading(false);
  };

  return (
    <div className="ed-gate">
      <aside className="ed-gate-marquee">
        <img src="/superpossible_logo.svg" alt="SuperPossible" />
        <h1 className="ed-gate-statement">
          Make the future feel <span className="ed-gate-accent">close enough to touch.</span>
        </h1>
        <span className="ed-gate-foot">Product Studio · Commercial Studio · App Builder</span>
      </aside>

      <main className="ed-gate-panel">
        <img src="/superpossible_logo.svg" alt="SuperPossible" />

        <div>
          <span className="ed-kicker">Access</span>
          <h2 className="ed-title" style={{ marginTop: 12 }}>
            Enter your key
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="ed-gate-form" autoComplete="off">
          <div className="ed-field">
            <label className="ed-label" htmlFor="superpossible-key">
              SuperPossible key
            </label>
            <input
              id="superpossible-key"
              name="access-key"
              type="password"
              className={`ed-input ed-input--display${error ? ' is-invalid' : ''}`}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              disabled={isLoading}
              {...noAutofill}
            />
            {error && (
              <span className="ed-error" role="alert">
                {error}
              </span>
            )}
          </div>

          <button
            type="submit"
            className="ed-btn ed-btn--primary ed-btn--lg ed-btn--block"
            disabled={isLoading || !password.trim()}
          >
            {isLoading ? (
              <>
                <span className="ed-spinner" aria-hidden="true" />
                Checking…
              </>
            ) : (
              <>
                Enter
                <ArrowRight size={15} />
              </>
            )}
          </button>
        </form>

        <p className="ed-meta">
          No key yet? Contact Soheil Sarmadi at{' '}
          <a href="mailto:soheil.sarmadi@capgemini.com">soheil.sarmadi@capgemini.com</a>.
        </p>
      </main>
    </div>
  );
};

export default Login;
